<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="60vw">
      <v-card style="border-radius: 20px">
        <v-card-title style="display: flex; align-items: center">
          <div style="font-size: 18px">
            <h2>{{ selected_item.contact_store_name_th }}</h2>
          </div>
          <v-spacer></v-spacer>
          <v-icon
            v-if="!is_approve"
            @click="closeDialog()"
            style="font-size: 30px"
            >close</v-icon
          >
        </v-card-title>
        <v-card-text
          class="pt-0"
          v-if="selected_item.contact_store_service_id_id == 1"
        >
          <div v-if="is_loading_data === true">
            <div class="loadingio-spinner-bean-eater-ml0cf77yxlj">
              <div class="ldio-4764vt8kr8z">
                <div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
                <div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            </div>
          </div>
          <div v-else style="max-height: 50vh; overflow: auto">
            <v-layout wrap style="overflow-x: hidden">
              <v-flex xs12 class="pa-1">
                <div class="body__content__item">
                  <h3>Contact information</h3>
                  <div>
                    <span class="pr-1 content__title">Store tel:</span
                    ><span class="content__text">{{
                      documentData.contact_store_tel
                    }}</span>
                  </div>
                  <div>
                    <span class="pr-1 content__title">Store email:</span
                    ><span class="content__text">{{
                      documentData.contact_email
                    }}</span>
                  </div>
                  <div>
                    <span class="pr-1 content__title">Store address:</span
                    ><span class="content__text">{{
                      documentData.contact_store_address
                    }}</span>
                  </div>
                  <div>
                    <span class="pr-1 content__title">Store service:</span
                    ><span class="content__text">{{
                      documentData.contact_store_service_id_id == 1
                        ? "Food"
                        : "Other"
                    }}</span>
                  </div>
                  <div>
                    <span class="pr-1 content__title">Store Province:</span
                    ><span class="content__text">{{
                      documentData.contact_store_province_name
                    }}</span>
                  </div>
                </div>
              </v-flex>
              <v-flex xs12 class="pa-1">
                <div class="body__content__item">
                  <h3>Owner information</h3>
                  <div>
                    <div>
                      <span class="pr-1 content__title">Name:</span
                      ><span class="content__text">{{
                        documentData.contact_user_name
                      }}</span>
                    </div>
                    <div>
                      <span class="pr-1 content__title">Email:</span
                      ><span class="content__text">{{
                        documentData.contact_user_email
                      }}</span>
                    </div>
                    <div>
                      <span class="pr-1 content__title">Tel:</span
                      ><span class="content__text">{{
                        documentData.contact_user_tel
                      }}</span>
                    </div>
                    <div>
                      <span class="pr-1 content__title">Store tel:</span
                      ><span class="content__text">{{
                        documentData.contact_store_tel
                      }}</span>
                    </div>
                  </div>
                </div>
              </v-flex>
              <v-flex xs12 class="mt-3 pa-1">
                <div class="body__content__item">
                  <h3>Document information</h3>
                  <v-layout wrap>
                    <v-flex xs12>
                      <div>
                        <span class="pr-1 content__title"
                          >Bank account type:</span
                        ><span class="content__text">{{
                          documentData.contact_bank_type == 2
                            ? "บุคคลธรรมดา"
                            : "นิติบุคคล"
                        }}</span>
                      </div>
                      <div>
                        <span class="pr-1 content__title">Bank name:</span
                        ><span
                          class="content__text"
                          v-if="documentData.contact_bank_id != null"
                          >{{
                            thaiBankList.find(
                              (val) => val.id == documentData.contact_bank_id
                            ).thbk_name_th
                          }}</span
                        >
                      </div>
                      <div>
                        <span class="pr-1 content__title"
                          >Bank account name:</span
                        ><span class="content__text">{{
                          documentData.contact_bank_account_name
                        }}</span>
                      </div>
                      <div>
                        <span class="pr-1 content__title"
                          >Bank account number:</span
                        ><span class="content__text">{{
                          documentData.contact_bank_account_number
                        }}</span>
                      </div></v-flex
                    >
                    <v-flex xs12>
                      <a
                        :href="documentData.contact_bank_image"
                        target="_blank"
                      >
                        <v-img
                          max-width="250px"
                          :src="documentData.contact_bank_image"
                        ></v-img></a
                    ></v-flex>
                  </v-layout>
                </div>
              </v-flex>
              <v-flex xs12 class="pa-1 mt-3">
                <div class="body__content__item">
                  <h3>Store bussiness image</h3>

                  <div style="display: flex; width: 750px; overflow-x: scroll">
                    <div
                      v-for="(info, index) in documentData.contact_business_img"
                      :key="index"
                      style="width: 200px"
                    >
                      <a target="_blank" :href="info.business_img">
                        <img
                          class="pr-1"
                          width="200px"
                          :src="info.business_img"
                      /></a>
                    </div>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </div>
          <v-divider class="my-2"></v-divider>
          <div style="color: grey; font-weight: bold; letter-spacing: 0.1rem">
            ( ร้านที่สมัครเข้ามาเป็นร้านแบบใด )
          </div>
          <v-radio-group row v-model="is_old_store">
            <v-radio label="New store" :value="false" color="primary"></v-radio>
            <v-radio
              label="From old store"
              :value="true"
              color="primary"
            ></v-radio>
          </v-radio-group>
          <v-select
            v-if="is_old_store === false"
            v-model="storePackageID"
            hide-details
            :loading="is_loading_data"
            :items="package_list"
            item-text="package_name"
            item-value="package_id"
            label="Select Package"
          ></v-select>
          <v-autocomplete
            v-model="form_old_store.store_id"
            :items="store_list"
            :loading="is_loading_data"
            :search-input.sync="search_store"
            clearable
            hide-details
            hide-selected
            item-text="store_name_th"
            item-value="store_id"
            label="Search store"
            v-if="is_old_store === true"
            outline
          />
        </v-card-text>
        <v-card-actions class="pt-0">
          <v-spacer />
          <v-btn
            :loading="isDeleting"
            :disabled="is_approve"
            flat
            color="red"
            class="black--text"
            @click="toDeleteContact()"
            >Delete</v-btn
          >
          <v-btn
            :loading="is_approve"
            :disabled="isDeleting"
            flat
            color="green darken-1"
            class="black--text"
            @click="approveContact()"
            >APPROVE</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import { mapActions, mapState } from "vuex";

export default {
  props: {
    dialog: {
      type: Boolean,
      default() {
        return false;
      },
    },
    selected_item: {
      type: Object,
      default() {
        return {
          contact_id: null,
          contact_store_tel: "",
          contact_store_address: "",
          contact_store_name_th: "",
          contact_store_service_id_id: null,
          contact_store_province_id: null,
          contact_store_province_name: null,
          contact_us_id_id: null,
          contact_user_id_id: null,
          contact_user_name: "",
        };
      },
    },
  },
  data() {
    return {
      isDeleting: false,
      radioGroup: "1",
      is_approve: false,
      store_list: [],
      package_list: [],
      form_old_store: {
        // get มาจาก api get contact by approved = 0
        contact_id: null,
        contact_store_province_id: null,
        contact_us_id_id: null,
        // get มาจาก api all store by province
        store_id: null, //เอา id ร้านนั้นที่จะมอบให้
        store_province_id: null, //จังหวัดของร้านนั้น
        // contact_bank_type: null,
        // contact_bank_id: null,
        // contact_bank_account_name: null,
        // contact_bank_account_number: null,
        // contact_bank_image: null,
        // contact_business_images: null,
      },
      search_store: false,
      is_old_store: false,
      is_loading_data: false,
      storePackageID: null,
      documentData: {
        contact_business_img: [],
      },
    };
  },
  watch: {
    async dialog() {
      if (this.dialog == true) {
        this.documentData = {
          contact_business_img: [],
        };
        this.resetFormOldStore();
        this.is_loading_data = true;
        if (this.selected_item.contact_store_province_name != null) {
          this.store_list = await this.$store.dispatch(
            "fetchStoreBack/manualGetStoreListByProvinceName",
            this.selected_item.contact_store_province_name
          );
          if (this.store_list.length > 0) {
            this.form_old_store.store_id = this.store_list[0].store_id;
          }
          this.package_list = await this.$store.dispatch(
            "fetchPackageBack/getPackageByProvince",
            this.selected_item.contact_store_province_name
          );
          if (this.package_list.length > 0) {
            this.storePackageID = this.package_list[0].package_id;
          }

          await this.fetchBankList();

          let response = await this.fetchDocumentByContactId(
            this.selected_item.contact_id
          );
          console.log(response);
          if (response != false) {
            this.documentData = response;
          }
        }
        this.is_loading_data = false;
      }
    },
  },
  computed: {
    ...mapState({
      thaiBankList: (state) => state.fetchDefaultRider.thai_bank,
    }),
  },
  methods: {
    ...mapActions({
      fetchDocumentByContactId:
        "fetchStoreApproveBack/fetchDocumentByContactId",
      fetchBankList: "fetchDefaultRider/getThaiBank",
    }),
    resetFormOldStore() {
      this.form_old_store = {
        // get มาจาก api get contact by approved = 0
        contact_id: null,
        contact_store_province_id: null,
        contact_us_id_id: null,
        // get มาจาก api all store by province
        store_id: null, //เอา id ร้านนั้นที่จะมอบให้
        store_province_id: null,
      };
    },
    async toDeleteContact(item) {
      let n = await this.$confirm("Do you want to delete this contact ?");
      if (n == true) {
        this.isDeleting = true;
        await this.$store.dispatch(
          "fetchStoreApproveBack/deleteContactStore",
          this.selected_item.contact_id
        );
        this.isDeleting = false;
        this.closeDialog();
      }
    },
    closeDialog() {
      this.$emit("setDialog", false);
      this.search_store = false;
      this.is_old_store = false;
      this.is_loading_data = false;
      this.is_approve = false;
      this.store_list = [];
    },
    async approveContact() {
      if (this.is_old_store == true) {
        this.form_old_store.contact_id = this.selected_item.contact_id;
        this.form_old_store.contact_store_province_id =
          this.selected_item.contact_store_province_id;
        this.form_old_store.contact_us_id_id =
          this.selected_item.contact_us_id_id;
        this.form_old_store.store_province_id =
          this.selected_item.contact_store_province_id;
        if ("contact_doc_bank_id" in this.documentData) {
          this.form_old_store.contact_doc_bank_id =
            this.documentData.contact_doc_bank_id;
          this.form_old_store.contact_bank_type =
            this.documentData.contact_bank_type;
          this.form_old_store.contact_bank_id =
            this.documentData.contact_bank_id;
          this.form_old_store.contact_bank_account_name =
            this.documentData.contact_bank_account_name;
          this.form_old_store.contact_bank_account_number =
            this.documentData.contact_bank_account_number;
          this.form_old_store.contact_bank_image =
            this.documentData.contact_bank_image;
          this.form_old_store.contact_business_images =
            this.documentData.contact_business_img.map(
              (val) => val.business_img
            );
        }
        let obj = JSON.parse(JSON.stringify(this.form_old_store));
        this.is_approve = true;
        let check = await this.$store.dispatch(
          "fetchStoreApproveBack/approveContactOldStore",
          obj
        );
        this.is_approve = false;
        if (check == true) {
          this.closeDialog();
        }
      } else if (this.is_old_store == false) {
        let payload = {
          user_id: this.selected_item.contact_user_id_id,
          contact_id: this.selected_item.contact_id,
          contact_store_package_id: this.storePackageID,
          contact_store_tel: this.selected_item.contact_store_tel,
          contact_store_address: this.selected_item.contact_store_address,
          contact_store_name_th: this.selected_item.contact_store_name_th,
          contact_store_service_id_id:
            this.selected_item.contact_store_service_id_id,
          contact_store_province_id:
            this.selected_item.contact_store_province_id,
          contact_store_province_name:
            this.selected_item.contact_store_province_name,
          contact_us_id_id: this.selected_item.contact_us_id_id,
          contact_user_id_id: this.selected_item.contact_user_id_id,
          contact_user_name: this.selected_item.contact_user_name,
          contact_email: this.selected_item.contact_email,
          contact_user_tel: this.selected_item.contact_user_tel,
          contact_user_email: this.selected_item.contact_user_email,
        };

        if ("contact_doc_bank_id" in this.documentData) {
          payload.contact_doc_bank_id =
            this.documentData.contact_doc_bank_id;
          payload.contact_bank_type =
            this.documentData.contact_bank_type;
          payload.contact_bank_id =
            this.documentData.contact_bank_id;
          payload.contact_bank_account_name =
            this.documentData.contact_bank_account_name;
          payload.contact_bank_account_number =
            this.documentData.contact_bank_account_number;
          payload.contact_bank_image =
            this.documentData.contact_bank_image;
          payload.contact_business_images =
            this.documentData.contact_business_img.map(
              (val) => val.business_img
            );
        }
        this.is_approve = true;
        let check = await this.$store.dispatch(
          "fetchStoreApproveBack/approveContactNewStore",
          payload
        );
        this.is_approve = false;
        if (check == true) {
          this.closeDialog();
        }
      } else {
        this.closeDialog();
      }
    },
  },
};
</script>

<style scoped>
.body__content__item {
  border: 1.5px solid #8080804f;
  padding: 10px;
  border-radius: 20px;
  padding: 20px;
}

.content__title {
  font-size: 16px;
  font-weight: 600;
}

.content__text {
  font-size: 14px;
  font-weight: 600;
  color: grey;
}

h3 {
  text-transform: uppercase;
}

@keyframes ldio-4764vt8kr8z-1 {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(-45deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
@keyframes ldio-4764vt8kr8z-2 {
  0% {
    transform: rotate(180deg);
  }
  50% {
    transform: rotate(225deg);
  }
  100% {
    transform: rotate(180deg);
  }
}
.ldio-4764vt8kr8z > div:nth-child(2) {
  transform: translate(-15px, 0);
}
.ldio-4764vt8kr8z > div:nth-child(2) div {
  position: absolute;
  top: 40px;
  left: 40px;
  width: 120px;
  height: 60px;
  border-radius: 120px 120px 0 0;
  background: #f8b26a;
  animation: ldio-4764vt8kr8z-1 1s linear infinite;
  transform-origin: 60px 60px;
}
.ldio-4764vt8kr8z > div:nth-child(2) div:nth-child(2) {
  animation: ldio-4764vt8kr8z-2 1s linear infinite;
}
.ldio-4764vt8kr8z > div:nth-child(2) div:nth-child(3) {
  transform: rotate(-90deg);
  animation: none;
}
@keyframes ldio-4764vt8kr8z-3 {
  0% {
    transform: translate(190px, 0);
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
  100% {
    transform: translate(70px, 0);
    opacity: 1;
  }
}
.ldio-4764vt8kr8z > div:nth-child(1) {
  display: block;
}
.ldio-4764vt8kr8z > div:nth-child(1) div {
  position: absolute;
  top: 92px;
  left: -8px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #e15b64;
  animation: ldio-4764vt8kr8z-3 1s linear infinite;
}
.ldio-4764vt8kr8z > div:nth-child(1) div:nth-child(1) {
  animation-delay: -0.67s;
}
.ldio-4764vt8kr8z > div:nth-child(1) div:nth-child(2) {
  animation-delay: -0.33s;
}
.ldio-4764vt8kr8z > div:nth-child(1) div:nth-child(3) {
  animation-delay: 0s;
}
.loadingio-spinner-bean-eater-ml0cf77yxlj {
  width: 200px;
  height: 200px;
  display: inline-block;
  overflow: hidden;
  background: #ffffff;
}
.ldio-4764vt8kr8z {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0; /* see note above */
}
.ldio-4764vt8kr8z div {
  box-sizing: content-box;
}
/* generated by https://loading.io/ */
</style>